<mlp-ng-input
    [inputId]="inputId"
    [inputName]="inputName"
    [inputType]="currentInputType"
    [inputStyle]="inputStyle"
    [inputDisabled]="inputDisabled"
    [placeholder]="placeholder"
    [icon]="icon"
    [iconSecondary]="currentInputType === 'password' ? 'custom-eye-closed' : 'custom-eye-open'"
    [loading]="loading"
    [input]="input"
    [errors]="errors"
    (blur)="blur.emit()"
    (focus)="focus.emit()"
    (secondaryButtonClick)="togglePassword()"
    [(ngModel)]="value"
></mlp-ng-input>
